import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class AdminProductTracksNewRoute extends Route {
  // Services
  @service breadcrumb;

  // Hooks
  model() {
    return this.breadcrumb.findRouteModelOrCreateRecord('product-track');
  }

  afterModel(model) {
    this.breadcrumb.registerDetailRoute(model);
  }
}
